export default "__VITE_ASSET__BaJ9NhsB__"